import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionDto, AIActionUsageStatsResponseDto } from '@/Domain/api/Action/dto/Action.dto';
import { HandoffDto } from '@/Domain/api/Action/dto/Handoff.dto';
import { useSubscription } from '@/Domain/components/SubscriptionProvider';
import { ActionsPage } from '@/UI/Actions/Actions.page';
import { ActionsPageSkeleton } from '@/UI/Actions/Actions.skeleton';

export const ActionsLoader = () => {
  const { isActivated, isFetched } = useSubscription();
  const isCampaignActivated = isActivated('campaigns');

  const { data, isLoading: isActionsLoading } = useQuery<ActionDto[]>({
    queryKey: [QueryKey.actions.basic.list],
  });

  const { data: statsData } = useQuery<AIActionUsageStatsResponseDto>({
    queryKey: [QueryKey.actions.basic.stats],
  });

  const { isLoading: isCampaignListLoading } = useQuery({
    queryKey: [QueryKey.campaign.list],
    enabled: isCampaignActivated,
  });

  const { isLoading: isHandoffLoading } = useQuery<HandoffDto>({
    queryKey: [QueryKey.handoff.get],
    enabled: isCampaignActivated,
  });

  const isReady =
    isFetched &&
    !isActionsLoading &&
    (!isCampaignActivated || (!isCampaignListLoading && !isHandoffLoading));
  return isReady ? (
    <ActionsPage actions={data!} stats={statsData?.stats} />
  ) : (
    <ActionsPageSkeleton />
  );
};
